/**
 * Copyright (C) Siemens AG 2016-2025 ALL RIGHTS RESERVED.
 */
import {Component, inject, Input} from '@angular/core';
import packageInfo from '../../../../package.json';
import {LogoService} from '../services/logo/logo.service';

@Component({
  selector: 'app-dynamic-footer',
  standalone: false,
  templateUrl: './dynamic-footer.component.html',
  styleUrl: './dynamic-footer.component.scss',
})
export class DynamicFooterComponent {
  year: number = new Date().getFullYear();
  protected readonly hideFooter = inject(LogoService).resolveHideFooter();

  @Input({required: false}) links: {
    text: string;
    href: string;
  }[] = [];

  @Input({required: false}) version = packageInfo.version;
}
